"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _reduxActions = require("redux-actions");

var _httpActions = require("../actions/http-actions");

var _util = require("./util");

var _servicingActions = require("../actions/servicing-actions");

var _handleActions;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var initialState = {
  drawEligibilityByAssetId: {// 'a6d3c3d4-369a-11e8-b467-0ed5f89f718b': {
    //   assetUuid: '',
    //   borrowerUuid: '',
    //   cutoffTime: '',
    //   maxAmount: 0,
    //   paymentChangeTime: '',
    //   currentMonthlyPayment: 0,
    //   primeRate: 0,
    //   parentPrimeRate: 0,
    //   marginInterest: 0,
    //   isPastDeadline: false,
    //   isDelinquent: false,
    //   isBelowMinDraw: false
    //   parentRate: 0,
    //   drawRate: 0,
    //   remainingTermMonths: 0,
    // }
  },
  payment: {
    assetUuid: '',
    amount: undefined,
    // number
    totalMonthlyPayment: undefined // number

  },
  error: '',
  loading: false
}; // TODO: darn protos; can standardize this into a util if we expect a lot of these going forwards

exports.initialState = initialState;

var parseProtoUuid = function parseProtoUuid(value) {
  return (value || {}).value || '';
};

var parseProtoMoney = function parseProtoMoney(value) {
  return parseFloat((value || {}).amount || 0);
};

var parseProtoDecimal = function parseProtoDecimal(value) {
  return parseFloat((value || {}).value || 0);
};

var reducer = (0, _reduxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, (0, _reduxActions.combineActions)("".concat(_servicingActions.GET_DRAW_ELIGIBILITY, "_").concat(_httpActions.REQUEST), "".concat(_servicingActions.GET_DRAW_ELIGIBILITIES, "_").concat(_httpActions.REQUEST)), function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  return _objectSpread(_objectSpread({}, state), {}, {
    error: '',
    loading: true
  });
}), (0, _defineProperty2.default)(_handleActions, "".concat(_servicingActions.GET_DRAW_ELIGIBILITIES, "_").concat(_httpActions.SUCCESS), function _(state, action) {
  var drawEligibilityByAssetId = action.payload.map(function (d) {
    return _objectSpread(_objectSpread({}, state.drawEligibilityByAssetId[parseProtoUuid(d.assetUuid)] || {}), {}, {
      assetUuid: parseProtoUuid(d.assetUuid),
      borrowerUuid: parseProtoUuid(d.borrowerUuid),
      eligible: d.eligible,
      cutoffTime: d.cutoffTime,
      maxAmount: parseProtoMoney(d.maxAmount),
      paymentChangeTime: d.paymentChangeTime,
      currentMonthlyPayment: parseProtoMoney(d.currentMonthlyPayment),
      primeRate: parseProtoDecimal(d.primeRate),
      parentPrimeRate: parseProtoDecimal(d.parentPrimeRate),
      marginInterest: parseProtoDecimal(d.marginInterest),
      isPastDeadline: d.isPastDeadline,
      isDelinquent: d.isDelinquent,
      isBelowMinDraw: d.isBelowMinDraw,
      remainingTermMonths: d.remainingTermMonths,
      parentRate: parseProtoDecimal(d.parentPrimeRate) + parseProtoDecimal(d.marginInterest),
      drawRate: parseProtoDecimal(d.primeRate) + parseProtoDecimal(d.marginInterest),
      parentInterestAggregate: parseProtoDecimal(d.parentInterestRate),
      drawInterestAggregate: parseProtoDecimal(d.interestRate)
    });
  }).reduce(function (result, d) {
    return _objectSpread(_objectSpread({}, result), {}, (0, _defineProperty2.default)({}, d.assetUuid, d));
  }, {});
  return _objectSpread(_objectSpread({}, state), {}, {
    drawEligibilityByAssetId: drawEligibilityByAssetId,
    loading: false
  });
}), (0, _defineProperty2.default)(_handleActions, "".concat(_servicingActions.GET_DRAW_ELIGIBILITY, "_").concat(_httpActions.SUCCESS), function _(state, action) {
  var assetUuid = parseProtoUuid(action.payload.assetUuid);
  var drawEligibility = state.drawEligibilityByAssetId[assetUuid] || {};
  return _objectSpread(_objectSpread({}, state), {}, {
    drawEligibilityByAssetId: (0, _defineProperty2.default)({}, assetUuid, _objectSpread(_objectSpread({}, drawEligibility), {}, {
      assetUuid: assetUuid,
      borrowerUuid: parseProtoUuid(action.payload.borrowerUuid),
      eligible: action.payload.eligible,
      cutoffTime: action.payload.cutoffTime,
      maxAmount: parseProtoMoney(action.payload.maxAmount),
      paymentChangeTime: action.payload.paymentChangeTime,
      currentMonthlyPayment: parseProtoMoney(action.payload.currentMonthlyPayment),
      primeRate: parseProtoDecimal(action.payload.primeRate),
      parentPrimeRate: parseProtoDecimal(action.payload.parentPrimeRate),
      marginInterest: parseProtoDecimal(action.payload.marginInterest),
      isPastDeadline: action.payload.isPastDeadline,
      isDelinquent: action.payload.isDelinquent,
      isBelowMinDraw: action.payload.isBelowMinDraw,
      remainingTermMonths: action.payload.remainingTermMonths,
      parentRate: parseProtoDecimal(action.payload.parentPrimeRate) + parseProtoDecimal(action.payload.marginInterest),
      drawRate: parseProtoDecimal(action.payload.primeRate) + parseProtoDecimal(action.payload.marginInterest),
      parentInterestAggregate: parseProtoDecimal(action.payload.parentInterestRate),
      drawInterestAggregate: parseProtoDecimal(action.payload.interestRate)
    })),
    loading: false
  });
}), (0, _defineProperty2.default)(_handleActions, "".concat(_servicingActions.SAVE_NEW_DRAW, "_").concat(_httpActions.SUCCESS), function _(state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    error: ''
  });
}), (0, _defineProperty2.default)(_handleActions, "".concat(_servicingActions.SAVE_NEW_DRAW, "_").concat(_httpActions.FAILURE), function _(state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    error: (0, _util.payloadError)(action)
  });
}), (0, _defineProperty2.default)(_handleActions, "".concat(_servicingActions.GET_DRAW_TOTAL_MONTHLY_PAYMENT, "_").concat(_httpActions.SUCCESS), function _(state, action) {
  var _action$meta = action.meta,
      uuid = _action$meta.uuid,
      amount = _action$meta.amount;
  return _objectSpread(_objectSpread({}, state), {}, {
    payment: {
      assetUuid: uuid,
      amount: amount,
      totalMonthlyPayment: action.payload
    }
  });
}), _handleActions), initialState);
var _default = reducer;
exports.default = _default;